/* src/app/components/analytics/facts-and-issues/facts/facts.component.scss */
.mat-body {
  font-size: 14px;
}
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  place-content: stretch center;
  align-items: stretch;
  flex: 1 1 98%;
}
.container > mat-toolbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
:host ::ng-deep .mat-sort-header-sorted {
  color: black;
}
.mat-mdc-row {
  position: relative;
}
.mat-column-delete {
  width: 40px;
}
.search-control {
  justify-content: flex-end;
}
.search-control > mat-form-field {
  font-size: 12px;
}
.mat-mdc-card.scrollable-content {
  display: flex;
  overflow: hidden;
  flex-direction: column;
  flex: 1 1;
}
.mat-mdc-card.scrollable-content > .mat-mdc-card-content {
  overflow-y: auto;
  flex: 1 1;
}
.mat-mdc-card.scrollable-content > .mat-mdc-card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
}
.column-border {
  flex: 1 1 100%;
  box-sizing: border-box;
  max-height: 10%;
}
.fact-title {
  color: #243e90;
}
.deleteIcon {
  color: #7a7a7a;
}
:host-context(.dark-theme) .fact-title {
  color: #88a3ff;
}
:host-context(.dark-theme) .deleteIcon {
  color: #b7b7b7;
}
.mat-mdc-card .mat-mdc-card-actions {
  --justify-content: flex-end;
}
/*# sourceMappingURL=facts.component.css.map */
